import { render, staticRenderFns } from "./DetailPatientQueue.vue?vue&type=template&id=92fb1336&scoped=true"
import script from "./DetailPatientQueue.vue?vue&type=script&lang=js"
export * from "./DetailPatientQueue.vue?vue&type=script&lang=js"
import style0 from "./DetailPatientQueue.vue?vue&type=style&index=0&id=92fb1336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fb1336",
  null
  
)

export default component.exports